import { z } from 'zod';
export const bloodPressureValidation = (checkboxFieldName = 'notChecked', options) => {
    const checkboxLabel = options?.checkboxLabel ?? 'Not Captured';
    const schema = z.object({
        [checkboxFieldName]: z.boolean().optional(),
        bloodPressures: z
            .array(z.object({
            systolic: z.string().optional(),
            diastolic: z.string().optional(),
            position: z.string().optional(),
            arm: z.string().optional(),
        }))
            .optional(),
    });
    return schema.superRefine((data, ctx) => {
        const checkboxValue = data[checkboxFieldName];
        const bloodPressures = Array.isArray(data.bloodPressures) ? data.bloodPressures : [];
        if (checkboxValue) {
            return;
        }
        let hasPartiallyFilled = false;
        let hasEmptyEntry = false;
        bloodPressures.forEach((bp) => {
            const requiredFields = [bp.systolic, bp.diastolic, bp.position, bp.arm];
            const filled = requiredFields.filter((f) => f?.trim()).length;
            if (filled > 0 && filled < 4) {
                hasPartiallyFilled = true;
            }
            else if (filled === 0) {
                hasEmptyEntry = true;
            }
        });
        if (hasPartiallyFilled || hasEmptyEntry) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `All fields in every blood pressure measurement must be filled. If not measured, click "${checkboxLabel}".`,
                path: [],
            });
        }
    });
};
